import { isEmpty, map } from "lodash";
import styles from "../MapView.module.scss";
import { MapImg } from "./img/Index";
import { MapToolTip } from "./tooltip/Index";
import cls from "classnames";
import React from "react";
export function CanvasView(props) {
  var mapboxClassName = cls(styles.mapboxContent, "nodrag", "nowheel");
  return /*#__PURE__*/React.createElement("div", {
    className: styles.mapboxCanvas
  }, /*#__PURE__*/React.createElement("div", {
    className: mapboxClassName
  }, /*#__PURE__*/React.createElement("div", {
    id: props.id,
    className: styles.inner
  }), !isEmpty(props.bloc.tipError.value) && /*#__PURE__*/React.createElement(MapToolTip, {
    bloc: props.bloc
  }), !isEmpty(props.bloc.map.value) ? /*#__PURE__*/React.createElement("div", {
    className: styles.mapToolBox
  }, /*#__PURE__*/React.createElement("span", {
    className: "iconfont icon-tianjia",
    onClick: function onClick(e) {
      return props.bloc.zoomIn(e);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "iconfont icon-jianshao",
    onClick: function onClick(e) {
      return props.bloc.zoomOut(e);
    }
  })) : null), isEmpty(props.bloc.mapList.value) ? /*#__PURE__*/React.createElement("div", {
    className: styles.noData
  }, "No data.") : /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.restaurantbox, " ").concat(props.noWheelClassName),
    style: {
      height: props.height - 360
    }
  }, map(props.bloc.mapList.value, function (address, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.restaurantItem,
      key: (address === null || address === void 0 ? void 0 : address.place_id) || "" + index
    }, /*#__PURE__*/React.createElement(MapImg, {
      placeId: (address === null || address === void 0 ? void 0 : address.place_id) || ""
    }), /*#__PURE__*/React.createElement("div", null, address.name), /*#__PURE__*/React.createElement("p", {
      className: styles.xingP
    }, address.rating && /*#__PURE__*/React.createElement("span", null, address.rating, " ", /*#__PURE__*/React.createElement("span", {
      className: "iconfont icon-wujiaoxing-"
    })), address.user_ratings_total && "(".concat(address.user_ratings_total, ")")), /*#__PURE__*/React.createElement("p", null, props.bloc.getAddressDetail(address)));
  })));
}